import React from 'react';
import ShortcutManager from '../ShortcutManager/ShortcutManager.mjs';

const ShortcutContext = /*#__PURE__*/React.createContext(null);
function ShortcutProvider({
  children
}) {
  const shortcutManager = React.useRef(new ShortcutManager());
  React.useEffect(() => {
    shortcutManager.current.setup();
  }, []);
  return /*#__PURE__*/React.createElement(ShortcutContext.Provider, {
    value: shortcutManager.current
  }, children);
}

export { ShortcutContext, ShortcutProvider as default };
